<template>
    <Header
        :main-logo="upperLeftLogo"
        :secondary-logo="secondaryLogo"
        :isCycloramaAvailable="isCycloramaAvailable"
        :isVirtualTourAvailable="isVirtualTourAvailable"
        :with-filter="withFilter"
        :with-menu="withMenu"
    />
    <section class="orbital vv-main" data-barba="container" data-barba-namespace="orbital">
        <swiper class="mainSwiper" :navigation="true" :modules="mainModules" :thumbs="{ swiper: thumbsSwiper }">
            <template v-for="file in files">
                <swiper-slide>
                    <img :src="file.file.url" alt="">
                </swiper-slide>
            </template>
        </swiper>

        <swiper class="thumbSwiper" :modules="thumbsModules" :spaceBetween="10" :slidesPerView="4" :freeMode="true" :watchSlidesVisibility="true" :watchSlidesProgress="true" @swiper="setThumbsSwiper">
            <template v-for="file in files">
                <swiper-slide>
                    <img :src="file.file.url" alt="">
                </swiper-slide>
            </template>
        </swiper>
    </section>
</template>

<script>
import Header from "../components/Header"
import Axios from "axios";
import { isPageActive } from "../composables/pages";

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Thumbs } from "swiper";

import 'swiper/css';
import "swiper/css/navigation";

export default {

    beforeMount() {
        Axios.get(process.env.MIX_APP_URL + '/domain?include=settings,files,videos,videos.formats,videos.thumb,tours,tours.thumb').then((response) => {
            this.domain = response.data.data;

            // This domain is fetched without its pages: the switch is read from the store's copy.
            if(!this.withMenu && isPageActive(this.$store.state.frontoffice.domain?.pages?.data, 'orbital')) {
                this.$router.push({name: 'orbital-show'});
            }

            if(!this.$cookies.isKey('promptCookie') && this.withModal) {
                this.$store.dispatch('modals/open', 'prompt-modal')
            }

            Axios.get(`${window.location.origin}/storage/cyclorama/${this.domain.name.toLowerCase()}/tour.xml`).then( (file) => {
                this.isCycloramaAvailable = file.headers['content-type'] === 'application/xml; charset=utf-8';
            })

            Axios.get(`${window.location.origin}/storage/vtour/${this.domain.name.toLowerCase()}/1/tour.xml`).then( (file) => {
                this.isVirtualTourAvailable = file.headers['content-type'] === 'application/xml; charset=utf-8';
            })
        })

        window.addEventListener('resize', this.onResize);
    },
    data() {
        return {
            isMenuOpen: false,
            domain: null,
            windowWidth: window.innerWidth,
            isCycloramaAvailable: false,
            isVirtualTourAvailable: false,
            mainModules: [Navigation, Thumbs],
            thumbsModules: [Thumbs],
            thumbsSwiper: null
        }
    },
    computed: {
        files() {
            if (this.domain) {
                return this.domain.files.data
            }

            return null
        },
        upperLeftLogo() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'upper-left-logo' ) && this.domain.settings.data.find( setting => setting.name === 'upper-left-logo' ).image) {
                return this.domain.settings.data.find( setting => setting.name === 'upper-left-logo' ).image.url
            }

            return null
        },
        secondaryLogo() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'secondary-logo' ) && this.domain.settings.data.find( setting => setting.name === 'secondary-logo' ).image) {
                return this.domain.settings.data.find( setting => setting.name === 'secondary-logo' ).image.url
            }

            return null
        },
        whiteLogo() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'white-logo' ) && this.domain.settings.data.find( setting => setting.name === 'white-logo' ).image) {
                return this.domain.settings.data.find( setting => setting.name === 'white-logo' ).image.url
            }

            return null
        },
        blackLogo() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'black-logo' ) && this.domain.settings.data.find( setting => setting.name === 'black-logo' ).image) {
                return this.domain.settings.data.find( setting => setting.name === 'black-logo' ).image.url
            }

            return null
        },
        splashImage() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'splash-image' ) && this.domain.settings.data.find( setting => setting.name === 'splash-image' ).image) {
                return this.domain.settings.data.find( setting => setting.name === 'splash-image' ).image.url
            }

            return '/img/landing-img.png'
        },
        withFilter() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'with-filter' )) {
                return !!Number(this.domain.settings.data.find( setting => setting.name === 'with-filter' ).value)
            }

            return false
        },
        withMenu() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'with-menu' )) {
                return !!Number(this.domain.settings.data.find( setting => setting.name === 'with-menu' ).value)
            }

            return false
        },
        withModal() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'with-modal' )) {
                return !!Number(this.domain.settings.data.find( setting => setting.name === 'with-modal' ).value)
            }

            return false
        }
    },
    methods: {
        Thumbs() {
            return Thumbs
        },
        onSwiper(swiper) {
        },
        onSlideChange() {
        },
        setThumbsSwiper(swiper) {
            this.thumbsSwiper = swiper;
        }
    },
    components: {
        Header,
        Swiper,
        SwiperSlide,
    }
}
</script>

<style>

    .mainSwiper {
        height: 80%;
        width: 100%;
    }

    .mainSwiper .swiper-button-prev, .swiper-button-next {
        z-index: 100;
        background-color: transparent;
    }

    .thumbSwiper {
        height: 20%;
        box-sizing: border-box;
        padding: 10px 0;
    }

    .thumbSwiper .swiper-slide {
        width: 25%;
        height: 100%;
        opacity: 0.4;
        background: #e0e0e0;
        overflow: hidden;
    }

    .thumbSwiper .swiper-slide-thumb-active {
        opacity: 1;
    }

    .mainSwiper .swiper-button-prev, .swiper-button-next{
        color: var(--base-color);

    }

    .swiper-slide img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .thumbSwiper .swiper-slide img {
        display: block;
        height: 100%;
        width: auto;
        object-fit: cover;
    }
    .swiper-button-next:after, .swiper-button-prev:after{
        color: var(--base-color);
    }
    .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }
</style>
